<template>
    <div class="p-4 max-w-sm mx-auto">
        <f-button class="is-warning is small" icon="fa-cloud-download-alt"
                  :disabled="loading || status === 'in_progress'"
                  @click="startSync">
            {{
                loading || status === 'in_progress' ? 'Syncing...' : '🔁 Sync data (Last synced: ' + (lastSync && lastSync.sync_date ? lastSync.sync_date : 'Never') + ')'
            }}
        </f-button>

        <div v-if="status" class="mt-4 text-center">
            <div v-if="status === 'in_progress'">
                <div class="w-full bg-gray-200 h-4 rounded overflow-hidden mt-2 relative">
                    <div
                        class="absolute inset-0 bg-gradient-to-r from-blue-400 via-blue-600 to-blue-400 animate-gradient" />
                </div>
                <div class="flex flex-col md:flex-row items-start md:items-center justify-between mt-2 gap-4">
                    <p class="text-sm text-blue-800 flashing-text font-mono">🔄 {{ progressMessage }}</p>
                    <div v-if="messageLog.length">
                        <ul class="text-left text-sm text-green-700 list-disc list-inside">
                            <li v-for="(msg, idx) in [...messageLog].reverse()" :key="idx">✅ {{ msg }}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div v-else-if="status === 'done'">
                <p class="text-green-600">✅ Sync completed</p>
            </div>
            <div v-else-if="status === 'error'">
                <p class="text-red-600">❌ Sync failed or unavailable {{ progressMessage }}</p>
            </div>
            <div v-else-if="status === 'idle'">
                <p class="text-gray-600">No sync in progress.</p>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .spinner {
        width: 30px;
        height: 30px;
        border: 4px solid #ccc;
        border-top-color: #007BFF;
        border-radius: 50%;
        animation: spin 0.8s linear infinite;
    }

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }

    @keyframes gradient {
        0% {
            background-position: 0% 50%;
        }
        50% {
            background-position: 100% 50%;
        }
        100% {
            background-position: 0% 50%;
        }
    }

    .animate-gradient {
        background-size: 200% 200%;
        animation: gradient 2s ease infinite;
    }

    @keyframes flash {
        0%, 100% {
            opacity: 1;
        }
        50% {
            opacity: 0.3;
        }
    }

    .flashing-text {
        animation: flash 1s infinite;
    }
</style>
<script>
    import axios from 'axios'
    import fButton from 'common/forms/fButton.vue'
    import lastSync from 'common/last_sync_date.json'

    export default {
        name: 'SyncStatusButton',
        components: { fButton },
        data() {
            return {
                status: null,
                progressMessage: '',
                messageLog: [],
                loading: false,
                intervalId: null,
                lastProgressMessage: '',
                lastSync

            }
        },
        beforeDestroy() {
            this.stopPolling()
        },
        methods: {
            startSync() {
                this.loading = true
                this.status = null
                this.progressMessage = ''
                this.messageLog = []
                this.lastProgressMessage = ''

                axios.post('/api/v1/venue/start_sync/')
                    .then(() => {
                        this.status = 'in_progress'
                        this.progressMessage = ''
                        this.startPolling()
                        this.$toast && this.$toast.success('✅ Sync started')
                    })
                    .catch((error) => {
                        console.error('Start sync error:', error)
                        this.status = 'error'
                        this.$toast && this.$toast.error('❌ Failed to start sync')
                    })
                    .finally(() => {
                        this.loading = false
                    })
            },
            fetchStatus(callback) {
                axios.get('/api/v1/venue/sync_status/')
                    .then(response => {
                        const raw = response && response.data ? response.data : response
                        console.log('Sync status response:', raw)

                        this.status = raw.status || 'idle'
                        const newMessage = raw.progress || ''

                        if (newMessage && newMessage !== this.lastProgressMessage) {
                            this.progressMessage = newMessage

                            // Only push to messageLog if it's NOT a "📊 Transferred" message
                            if (this.lastProgressMessage && !this.lastProgressMessage.includes('📊 Transferred'))
                                this.messageLog.push(this.lastProgressMessage)


                            this.lastProgressMessage = newMessage
                        }

                        if (this.status === 'done') {
                            if (!this.progressMessage.includes('📊 Transferred'))
                                this.messageLog.push(this.progressMessage)

                            this.$toast && this.$toast.success('✅ Sync completed')
                            setTimeout(() => {
                                location.reload()
                            }, 5000)
                        } else if (this.status === 'error')
                            this.$toast && this.$toast.error('❌ Sync failed')

                    })
                    .catch((error) => {
                        console.error('Fetch sync status error:', error)
                        this.status = 'error'
                        this.progressMessage = ''
                        this.$toast && this.$toast.error('❌ Unable to fetch sync status')
                    })
                    .finally(() => {
                        if (callback) callback()
                    })
            }
            ,
            startPolling() {
                if (this.intervalId) return

                this.intervalId = setInterval(() => {
                    this.fetchStatus(() => {
                        if (this.status !== 'in_progress')
                            this.stopPolling()

                    })
                }, 1000)
            },
            stopPolling() {
                clearInterval(this.intervalId)
                this.intervalId = null
            }
        }
    }
</script>


